import { useMemo } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

// project imports
import useConfig from 'hooks/useConfig';

// assets
import BulbOutlined from '@ant-design/icons/BulbOutlined';

// ==============================|| HEADER CONTENT - MODE TOGGLE ||============================== //

export default function ModeToggle() {
  const theme = useTheme();
  const { state, setField } = useConfig();
  const { mode } = state;

  const handleToggleMode = () => {
    setField('mode', mode === 'light' ? 'dark' : 'light');
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 0.75 }}>
      <Tooltip title={mode === 'dark' ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
        <IconButton
          disableRipple
          color="secondary"
          title="Toggle Theme Mode"
          sx={{ color: mode === 'dark' ? 'warning.main' : 'text.secondary', bgcolor: mode === 'dark' ? 'grey.900' : 'grey.100', '&:hover': { bgcolor: mode === 'dark' ? 'grey.800' : 'grey.200' } }}
          onClick={handleToggleMode}
        >
          <BulbOutlined />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
